import React, { useEffect, useState } from "react"

import { MainNavProps } from "../navigation/main/MainParamList"
import { Str_Contacts, Str_GroupChat, Str_Include } from "../../language/string_res"
import { color_333333, color_999999, white } from "../../assets/style/colors"
import { Pressable, SectionList, StyleSheet, } from "react-native"
import { useNavigationToChatView2 } from "./chat-helper"
import { LeftView } from "./CListItem"
import * as ImSdk from "../../../imsdk/api";
import { Avatar } from "../../../imsdk/api/topic"
import { GroupMember } from "../../../imsdk/db/t_group_member"
import { Group } from "../../../imsdk/db/t_group"
import { ListEmpty } from "../../components/ListEmpty"
import { CommonText, Div, SectionHeader } from "./ChatSearch"
import { useIsFocused } from "@react-navigation/native"
import { ScreenCloseModal } from "../../components/ScreenModal"
import { ChatSearchInput } from "./components/ChatSearchInput"

type ChatSearchData = {
    title: string;
    data: { subText: string, data: any }[];
};
let searchTimer: any = null

export const MoreChatGroupSearch = ({ navigation, route }: MainNavProps<'MoreChatGroupSearch'>) => {
    const { curSearch, data } = route.params
    const [searchText, setSearchText] = useState(curSearch)
    const [section, setSection] = useState<ChatSearchData[]>([]);
    const toChatView = useNavigationToChatView2();
    const isFocused = useIsFocused()
    useEffect(() => {
        if (isFocused && data && data.length > 0) {
            setSection([{
                title: Str_Contacts,
                data: data
            }])
        }
    }, [isFocused, data])
    const onChangeText = (text: string) => {
        // 清除之前的定时器（如果有）  
        if (searchTimer) {
            clearTimeout(searchTimer);
        }
        setSearchText(text)
        // 设置新的定时器  
        searchTimer = setTimeout(() => {
            // 定时器到期，执行搜索  
            startSearch(text)
            // 这里可以替换为实际的搜索逻辑  
        }, 500);
    }
    const startSearch = (text: string) => {
        const sections: ChatSearchData[] = []
        if (text.length === 0) {
            setSection(sections)
            return
        }
        const searchGroup = async () => {
            let data: { data: any, subText: string }[] = [];
            function filterMember(group: Group, members: GroupMember[]) {
                const n = members.length
                for (let i = 0; i < n; i++) {
                    const user = members[i]
                    if (user.remark && user.remark.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: group, subText: `${Str_Include}：${user.remark}` })
                        break
                    }
                    if (user.nick && user.nick.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: group, subText: `${Str_Include}：${user.nick}` })
                        break
                    }
                    if (user.email && user.email.toLowerCase().includes(text.toLowerCase())) {
                        const name = user.remark || user.nick || ''
                        const text = name.length > 0 ? `${Str_Include}：${name}(${user.email})` : `${Str_Include}：${user.email}`
                        data.push({ data: group, subText: text })
                        break
                    }
                    if (user.telno && user.telno.toLowerCase().includes(text.toLowerCase())) {
                        const name = user.remark || user.nick || ''
                        const text = name.length > 0 ? `${Str_Include}：${name}(${user.telno})` : `${Str_Include}：${user.telno}`
                        data.push({ data: group, subText: text })
                        break
                    }
                }
            }

            const res = await ImSdk.getInstance().GetGroupSummaryList()
            if (res.groupSummarys && res.groupSummarys.length > 0) {
                const n = res.groupSummarys.length
                for (let i = 0; i < n; i++) {
                    const summary = res.groupSummarys[i]
                    const r = await ImSdk.getInstance().GetGroupDetail(summary.tid, true)
                    if (r.group && r.group.remark.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: r.group, subText: '' })
                    } else if (r.group && r.group.name.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: r.group, subText: '' })
                    } else {
                        if (r.group && r.members) {
                            filterMember(r.group, r.members)
                        }
                    }
                }
                const l = data.length
                data = l <= 3 ? data : data.slice(0, 3)
                if (data.length > 0) {
                    const item: ChatSearchData = {
                        title: Str_GroupChat,
                        data: data
                    }
                    sections.push(item)
                }
            }

        }

        const search2 = searchGroup()

        Promise.all([search2,]).then(r => {
            setSection(sections)
        })
    }


    const RenderItem = ({ item }: { item: { subText: string, data: any } }) => {
        const group = item.data as Group
        const name = group.remark || group.name || Str_GroupChat
        const left: Avatar = { avatar: group?.avatar, name: '', uid: 0 };
        const onClick = () => {
            ImSdk.getInstance().GetTopicDetail(group.tid).then((res) => {
                if (res.topic) {
                    toChatView(res.topic).then();
                    navigation.goBack()
                }
            });

        };

        return (<Pressable
            onPress={onClick}
            style={styles.userContainer} >
            <LeftView left={left} size={50} isRounded={true} isGroup={true} />
            {CommonText(name, item.subText)}
        </Pressable>)
    }

    return (<ScreenCloseModal>
        <ChatSearchInput searchText={searchText} onChangeText={onChangeText} />
        <SectionList
            sections={section}
            keyExtractor={(item, index) => index.toString()}
            renderItem={RenderItem}
            ItemSeparatorComponent={Div}
            ListEmptyComponent={() => {
                if (searchText && searchText.length > 0) {
                    return (<ListEmpty />)
                }
                return null
            }}
            renderSectionHeader={({ section }) => (<SectionHeader title={section.title} />)} />

    </ScreenCloseModal>)
}
const styles = StyleSheet.create({
    header: {
        fontSize: 13,
        marginStart: 16,
        paddingVertical: 8,
        color: "#737373"
    },
    userContainer: {
        flexDirection: "row",
        backgroundColor: white,
        paddingVertical: 8,
        paddingHorizontal: 12,
        alignItems: "center",
    },
    userTitle: {
        color: color_333333,
        fontSize: 14,
        width: '100%',
        fontWeight: 'bold',
        fontFamily: '',
    },
    subUserTitle: {
        color: color_999999,
        width: '100%',
        fontSize: 12,
    },
})